import getScrollAccessor from './getScrollAccessor';
export default getScrollAccessor('pageYOffset');


//////////////////
// WEBPACK FOOTER
// ./~/dom-helpers/esm/scrollTop.js
// module id = 281
// module chunks = 0